import Prism from "prismjs";
import "prismjs/components/prism-java";
import "prismjs/components/prism-json";
import "prismjs/components/prism-javascript";
import "@/assets/css/prism/prism-material-oceanic.css";

Prism.highlightAll();
